export default {
  v3SubmitErrBtnViewOrder: 'ดูคำสั่งซื้อ',
  v3SubmitErrBtnBackHome: 'กลับหน้าแรก',
  v3SubmitErrBtnRetry: 'ลองใหม่',
  v3SubmitErrBtnRelogin: 'เข้าสู่ระบบอีกครั้ง',
  v3SubmitErrBtnSwitchPay: 'เปลี่ยนวิธีการชำระเงิน',
  v3SubmitErrBtnReorder: 'สั่งซื้อใหม่',
  v3SubmitErrBtnSwitchServer: 'เปลี่ยนเซิร์ฟเวอร์',
  v3SubmitErrBtnViewOrderStatus: 'สถานะคำสั่งซื้อ',
  v3SubmitErrBtnBackStore: 'กลับไปที่ร้านค้า',
  v3SubmitErrBtnGoUpdate: 'อัปเดต',
  v3SubmitErrBtnResubscribe: 'สมัครใหม่',
  v3SubmitErrTipUpdateApp: 'กรุณาอัปเดตที่ App Store',
  v3SubmitErrTipRelogin: 'กรุณาเข้าสู่ระบบอีกครั้ง',

  v3SubmitErrMsg120009: 'คำสั่งซื้อได้รับการดำเนินการแล้ว กรุณาตรวจสอบกระเป๋าในเกม',
  v3SubmitErrMsg120003: 'ข้อมูลสินค้าผิดพลาด กรุณาเลือกสินค้าใหม่',
  v3SubmitErrMsg120016: 'ส่งข้อมูลบ่อยเกินไป กรุณารอสักครู่แล้วลองอีกครั้ง',
  v3SubmitErrMsg120025: 'พารามิเตอร์คำขอผิดปกติ กรุณาเข้าสู่ระบบอีกครั้งแล้วลองใหม่',
  v3SubmitErrMsg121012: 'ช่องทางชำระเงินไม่พร้อมใช้งานชั่วคราว กรุณาลองวิธีอื่น',
  v3SubmitErrMsg120012: 'เครือข่ายไม่เสถียร กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่',
  v3SubmitErrMsg120002: 'ไม่พบตัวละครในเกม กรุณาสร้างตัวละครก่อน',
  v3SubmitErrMsg121019: 'ข้อมูลคำสั่งซื้อผิดพลาด กรุณาสั่งซื้อใหม่',
  v3SubmitErrMsg120024: 'ของขวัญพรีรีจิสเตอร์ได้รับแล้ว ไม่ต้องดำเนินการซ้ำ',
  v3SubmitErrMsg120000: 'การเข้าสู่ระบบหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
  v3SubmitErrMsg120014: 'หมายเลขคำสั่งซื้อไม่ถูกต้อง กรุณาสั่งซื้อใหม่',
  v3SubmitErrMsg121001: 'การเติมเงินในเกมล้มเหลว กรุณาลองใหม่ภายหลังหรือติดต่อฝ่ายช่วยเหลือ',
  v3SubmitErrMsg120015: 'จำนวนเงินชำระผิดปกติ กรุณาเลือกสินค้าใหม่',
  v3SubmitErrMsg120001: 'เซิร์ฟเวอร์ไม่ตรงกัน กรุณาสลับไปยังเซิร์ฟเวอร์ที่ถูกต้อง',
  v3SubmitErrMsg120020: 'ช่องทางชำระเงินคืนค่าผิดปกติ กรุณาลองวิธีอื่น',
  v3SubmitErrMsg120010: 'ฟังก์ชันเติมเงินในเกมปิดให้บริการชั่วคราว กรุณาลองใหม่ภายหลัง',
  v3SubmitErrMsg120006: 'การตรวจสอบจำนวนเงินล้มเหลว กรุณาเลือกใหม่',
  v3SubmitErrMsg121010: 'คำขอเติมเงินในสภาพแวดล้อมแซนด์บ็อกซ์ไม่ถูกต้อง กรุณาใช้เวอร์ชันทางการ',
  v3SubmitErrMsg120017: 'หมายเลขคำสั่งซื้อซ้ำ กรุณาตรวจสอบว่าชำระเงินแล้วหรือไม่',
  v3SubmitErrMsg120022: 'การตรวจสอบ callback การชำระเงินล้มเหลว กรุณาลองใหม่ภายหลัง',
  v3SubmitErrMsg121000: 'ระบบไม่ว่าง กรุณาลองใหม่ภายหลัง',
  v3SubmitErrMsg120011: 'รหัสสินค้าผิดพลาด กรุณาเลือกใหม่',
  v3SubmitErrMsg121015: 'การตรวจสอบจำนวนเงินชำระล้มเหลว กรุณาสั่งซื้อใหม่',
  v3SubmitErrMsg120004: 'ช่องทางชำระเงินปัจจุบันยังไม่เปิด กรุณาเลือกวิธีอื่น',
  v3SubmitErrMsg120005: 'ช่องทางชำระเงินอยู่ระหว่างการบำรุงรักษา กรุณาใช้วิธีอื่น',
  v3SubmitErrMsg120007: 'รหัสแพลตฟอร์มไม่ถูกต้อง กรุณาเข้าสู่ระบบอีกครั้ง',
  v3SubmitErrMsg120008: 'พารามิเตอร์คำขอไม่เพียงพอ กรุณาส่งใหม่',
  v3SubmitErrMsg120013: 'หมายเลขคำสั่งซื้อของนักพัฒนาไม่ถูกต้อง กรุณาสั่งซื้อใหม่',
  v3SubmitErrMsg120018: 'การชำระเงินถูกบล็อกโดยระบบควบคุมความเสี่ยง กรุณาติดต่อฝ่ายช่วยเหลือเพื่อตรวจสอบ',
  v3SubmitErrMsg120019: 'การตรวจสอบชื่อแพ็คเกจล้มเหลว กรุณาใช้เวอร์ชันทางการ',
  v3SubmitErrMsg120021: 'การตรวจสอบรหัสสินค้าล้มเหลว กรุณาเลือกใหม่',
  v3SubmitErrMsg120023: 'การแจกของขวัญพรีรีจิสเตอร์ผิดปกติ กรุณาตรวจสอบภายหลัง',
  v3SubmitErrMsg120026: 'ไม่พบบัญชีผู้ใช้ กรุณาตรวจสอบสถานะบัญชี',
  v3SubmitErrMsg120030: 'สินค้าคงคลังทั้งหมดไม่เพียงพอ กรุณาเลือกสินค้าอื่น',
  v3SubmitErrMsg120031: 'คุณซื้อสินค้านี้เกินจำนวนจำกัดแล้ว กรุณาปรับ',
  v3SubmitErrMsg120032: 'เวอร์ชันเกมเก่าเกินไป กรุณาดาวน์โหลดเวอร์ชันล่าสุด',
  v3SubmitErrMsg120080: 'การชำระเงินผ่านตัวแทนถูกจำกัดโดยระบบควบคุมความเสี่ยง กรุณาใช้วิธีการชำระเงินของตนเอง',
  v3SubmitErrMsg120081: 'การชำระเงินผ่านตัวแทนล่าช้าโดยระบบควบคุมความเสี่ยง กรุณาตรวจสอบผลภายหลัง',
  v3SubmitErrMsg121002: 'แคชคำสั่งซื้อไม่ถูกต้อง กรุณาสั่งซื้อใหม่',
  v3SubmitErrMsg121003: 'ไม่พบการกำหนดค่าการเติมเงิน กรุณาติดต่อฝ่ายช่วยเหลือ',
  v3SubmitErrMsg121004: 'พารามิเตอร์เพิ่มเติมไม่เพียงพอ กรุณาส่งใหม่',
  v3SubmitErrMsg121005: 'การเขียนแคชล้มเหลว กรุณาลองใหม่ภายหลัง',
  v3SubmitErrMsg121006: 'การอ่านแคชล้มเหลว กรุณาลองใหม่ภายหลัง',
  v3SubmitErrMsg121007: 'การกำหนดค่าประเภทการเติมเงินผิดพลาด กรุณาติดต่อฝ่ายช่วยเหลือ',
  v3SubmitErrMsg121011: 'ตรวจพบฟิลด์ใหม่จากช่องทาง Apple กรุณาอัปเดตแอป',
  v3SubmitErrMsg121013: 'ไม่พบคำสั่งซื้อต่ออายุ กรุณาสมัครสมาชิกใหม่',
  v3SubmitErrMsg121014: 'การถอดรหัสพารามิเตอร์การเติมเงินล้มเหลว กรุณาส่งใหม่',
  v3SubmitErrMsg121017: 'คำสั่งซื้อนี้ได้รับการคืนเงินแล้ว กรุณาติดต่อฝ่ายช่วยเหลือเพื่อยืนยัน',
  v3SubmitErrMsg121018: 'การสมัครสมาชิกหมดอายุแล้ว กรุณาสมัครใหม่',
  v3SubmitErrMsg121020: 'คำสั่งซื้อถูกยกเลิก กรุณาสั่งซื้อใหม่',
  v3SubmitErrMsg121021: 'Google API ผิดปกติ กรุณาลองใหม่ภายหลัง',
  v3SubmitErrMsg121022: 'การรับโทเค็นการเข้าถึงล้มเหลว กรุณาเข้าสู่ระบบอีกครั้ง',
  v3SubmitErrMsg121023: 'สถานะคำสั่งซื้อผิดปกติ กรุณาตรวจสอบสถานะการเข้าเงิน',
  v3SubmitErrMsg121024: 'การยืนยันคำสั่งซื้อล้มเหลว กรุณาลองใหม่ภายหลัง'
};
